var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AfterViewInit, OnInit } from '@angular/core';
import { config } from '../../../../config/config';
import { ImageService } from '../../../services/image.service';
import { BaseComponent } from '../base.component';
import { ActivatedRoute } from '@angular/router';
var PoweredByComponent = /** @class */ (function (_super) {
    __extends(PoweredByComponent, _super);
    function PoweredByComponent(imageService, activatedRoute) {
        var _this = _super.call(this, { activatedRoute: activatedRoute }) || this;
        _this.imageService = imageService;
        _this.activatedRoute = activatedRoute;
        _this.hostClass = '';
        _this.itiLogoUrl = '';
        _this.googleLogoUrl = '';
        _this.hubName = '';
        // these clients want to hide ITI logo
        _this.hideForClients = ['EurekaCA', 'test', 'TalbotCoMD'];
        return _this;
    }
    PoweredByComponent.prototype.ngOnInit = function () {
        var hubName = this.allRouteParams.hubName;
        this.hubName = hubName;
        if (this.hideForClients.indexOf(hubName) >= 0) {
            this.hostClass = 'max-w-0';
        }
    };
    PoweredByComponent.prototype.ngAfterViewInit = function () {
        this.itiLogoUrl = this.imageService.imageSourceUrl(config.serverDomain + '/assets/imgs/iti.png');
        this.googleLogoUrl = this.imageService.imageSourceUrl(config.serverDomain + '/assets/imgs/google-logo.png');
    };
    PoweredByComponent.prototype.gotoITI = function () {
        window.open('https://iti-digital.com/', '_blank');
    };
    return PoweredByComponent;
}(BaseComponent));
export { PoweredByComponent };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/powered.by/powered.by.component.ts.pre-build-optimizer.js